import { useState, useEffect } from 'react'
import { TableBox, Tabs } from "@lk-gtcom/ecomlab-components"
import { CardDynamic } from '../../components/CardsComponents/CardDynamic/CardDynamic'
import { OlegHttps, OlegHttp } from '../../fetchUrls'
import customHeaders, { getSpace } from '../../common/headers';
import useGeneralStore from '../../store/general';
import { TextPage } from '../../components/TextPage/TextPage';
import { msToLocalDate } from '../../common/constant';
import "./ProductCardExtended_Feedbacks.scss"

const tabs_list = [
    {
        label: 'Список отзывов',
        value: 'list_reviews',
    },
    {
        label: 'Проанализировать товар',
        value: 'analyze_product',
    },
];

const ProductCardExtended_Feedbacks = ({
    tableData,
    tableCallback,
    checkFbs,
    nmid,
    apiId,
    date,
    paginatorRef
}) => {

    const [productMetrics, setProductMetrics] = useState([]);
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const [pageValue, setPageValue] = useState(tabs_list[0].value)
    const [jsonData, setJsonData] = useState('')

    const fetchProductCardGeneral = (abortController = new AbortController()) => {
        const api_id = `?api_id=${apiId}`
        const offer_id = `&offer_id=${nmid}`
        const fbs = `&fbs=${checkFbs}`

        let url = `${OlegHttps}/api/v1/analysis/product/card/feedbacks${api_id + offer_id + fbs}`;

        const [date_from, date_to] = date;

        const body = JSON.stringify({
            date_from: msToLocalDate(date_from),
            date_to: msToLocalDate(date_to),
            limit: paginatorRef.current?.limit || 10,
            page: paginatorRef.current?.page || 1,
        });

        fetch(url, {
            body,
            method: 'POST',
            headers,
            signal: abortController.signal,
        })
            .then(async (res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    const err = await res.json();
                    throw new Error(JSON.stringify(err));
                }
            })
            .then((json) => {
                setProductMetrics(json);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                if (abortController.signal.aborted) return;
            });
    };

    // анализ товара
    const fetchAnalys = (abortController = new AbortController()) => {

        let url = `https://apps1.ecomru.ru:4456/products/reviews/summary/create`

        const [date_from, date_to] = date;

        const body = JSON.stringify({
            date_from: msToLocalDate(date_from),
            date_to: msToLocalDate(date_to),
            api_id: apiId,
            offer_id: nmid
        });

        fetch(url, {
            body,
            method: 'POST',
            headers,
            signal: abortController.signal,
        })
            .then(async (res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    const err = await res.json();
                    throw new Error(JSON.stringify(err));
                }
            })
            .then((json) => {
                setJsonData(JSON.stringify(json));
            })
            .catch((err) => {
                setJsonData('Информация отсутствует');
                console.error(err);
            })
            .finally(() => {
                if (abortController.signal.aborted) return;
            });
    };

    useEffect(() => {
        fetchAnalys()
        fetchProductCardGeneral()
    }, [date]);

    return (
        <section className='feedbacks-inside-content'>
            <Tabs
                tabs={tabs_list}
                stopRedirect
                pageValue={pageValue}
                setPageValue={(e) => setPageValue(e)}
            />

            <div className='card-group'>
                {productMetrics?.length > 0
                    ? productMetrics?.map((data, i) => (
                        <CardDynamic key={JSON.stringify(data)} {...data} />
                    ))
                    : [...Array(5)]?.map((e, i) => (
                        <CardDynamic key={i} title={''} dynamic={''} value={''} />
                    ))}
            </div>

            {pageValue == 'list_reviews' ? <TableBox
                {...tableData}
                sortingFunc={tableCallback}
                fetchCallback={tableCallback}
                paginator={true}
            />
                :
                <TextPage
                    text={jsonData}
                />
            }
        </section>
    )
}

export { ProductCardExtended_Feedbacks }